// tslint:disable-next-line
const designSystemVersion = require("../../../../../design-system/package.json").version;
// tslint:disable-next-line
const bundleVersion = require("../../../../../bundle-emcm/package.json").version;
import * as React from 'react';
import { Component } from 'react';
import withSizes from 'react-sizes';
import styled from 'react-emotion';
import { Link } from 'docz';
import { Logo } from '../Logo';
import { SearchCtxConsumer } from '../Search/SearchContext';
import { Menu } from './Menu';
import { Hamburguer } from './Hamburguer';
import { Search } from '../Search';
import { get } from '@utils/theme';
import { mq, breakpoints } from '@styles/responsive';
const designSystemUrl = `/docs-about-releases-v${bundleVersion.replace(/\./g, "-")}`;
const sidebarBg = get('colors.sidebarBg');
const sidebarText = get('colors.sidebarText');
const sidebarBorder = get('colors.sidebarBorder');
const Wrapper = styled('div') `
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.05);
  position: relative;
  width: var(--sidebar-width);
  min-width: var(--sidebar-width);
  min-height: calc(100vh - var(--colorbar-height));
  background: ${sidebarBg};
  transition: transform 0.2s, background 0.3s;
  z-index: 2;

  ${get('styles.sidebar')};
  ${mq({
    position: ['absolute', 'absolute', 'absolute', 'relative'],
})};

  dt {
    padding: 4px 0;
    &:first-of-type {
      padding-top: 8px;
    }
  }

  dl {
    padding: 0;
    margin: 0;
  }

  @media screen and (max-width: ${breakpoints.desktop - 1}px) {
    transform: translateX(${(p) => (p.opened ? '-100%' : '0')});
  }
`;
const Content = styled('div') `
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  width: var(--sidebar-width);
  min-width: var(--sidebar-width);
  height: 100%;
  max-height: 100vh;
  padding-top: var(--colorbar-height);
`;
const Menus = styled('nav') `
  flex: 1;
  overflow-y: auto;
  margin-bottom: 10px;
`;
const Empty = styled('div') `
  flex: 1;
  opacity: 0.7;
  padding: 0 24px;
  color: ${sidebarText};
`;
const ToggleBackground = styled('div') `
  content: '';
  display: ${(p) => (p.opened ? 'none' : 'block')};
  position: fixed;
  background-color: rgba(0, 0, 0, 0.4);
  width: 100vw;
  height: 100vh;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  cursor: pointer;
  z-index: 1;
`;
const SearchWrapper = styled.div `
  padding: 0 var(--sidebar-padding);
  margin-bottom: 36px;
`;
const VersionWrapper = styled.div `
  padding: 0 var(--sidebar-padding);
  margin-bottom: 36px;
  a {
    background-color: rgba(0, 0, 0, 0);
    box-sizing: border-box;
    color: rgb(64, 64, 64);
    cursor: pointer;
    display: block;
    font-family: proximanova, "Helvetica Neue", Arial, sans-serif;
    font-size: 18px;
    font-weight: 500;
    height: 30px;
    letter-spacing: -0.36px;
    line-height: 27px;
    position: relative;
    text-decoration-color: rgb(64, 64, 64);
    text-decoration-line: none;
    text-decoration-style: solid;
    text-size-adjust: 100%;
    transition-delay: 0s;
    transition-duration: 0.2s;
    transition-property: color;
    transition-timing-function: ease;
    width: 260px;
  }
  a:visited {
    color: rgb(64,64,64);
  }
`;
class SidebarBase extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            hidden: true,
        };
        this.toggleOverlayClass = () => {
            const { isDesktop } = this.props;
            const { hidden } = this.state;
            const method = !hidden ? this.addOverlayClass : this.removeOverlayClass;
            if (window && typeof window !== 'undefined' && !isDesktop) {
                method();
            }
        };
        this.handleSidebarToggle = () => {
            if (this.props.isDesktop)
                return;
            this.setState({ hidden: !this.state.hidden });
        };
    }
    componentDidUpdate(pProps, pState) {
        const { isDesktop } = this.props;
        const { hidden } = this.state;
        if (pState.hidden !== this.state.hidden) {
            this.toggleOverlayClass();
        }
        if (pProps.isDesktop !== isDesktop && !hidden && isDesktop) {
            this.setState({ hidden: true });
            this.removeOverlayClass();
        }
    }
    componentDidMount() {
        this.toggleOverlayClass();
    }
    render() {
        const { hidden } = this.state;
        const { isDesktop } = this.props;
        return (React.createElement(SearchCtxConsumer, null, ({ menus, searching }) => (React.createElement(React.Fragment, null,
            React.createElement(Wrapper, { opened: hidden },
                React.createElement(Content, null,
                    React.createElement(Hamburguer, { opened: !hidden, onClick: this.handleSidebarToggle }),
                    React.createElement(Logo, { showBg: !hidden }),
                    React.createElement(SearchWrapper, null,
                        React.createElement(Search, null)),
                    menus.length === 0 ? (React.createElement(Empty, null, "No documents found.")) : (React.createElement(Menus, null, menus.map(menu => (React.createElement(Menu, { key: menu.name, item: menu, sidebarToggle: this.handleSidebarToggle, collapseAll: Boolean(searching), levels: menu.levels || 0, level: 0, isDesktop: isDesktop }))))),
                    React.createElement(VersionWrapper, null,
                        React.createElement(Link, { to: designSystemUrl },
                            "v",
                            designSystemVersion)))),
            React.createElement(ToggleBackground, { opened: hidden, onClick: this.handleSidebarToggle })))));
    }
    removeOverlayClass() {
        document.documentElement.classList.remove('with-overlay');
    }
    addOverlayClass() {
        document.documentElement.classList.add('with-overlay');
    }
}
const mapSizesToProps = ({ width }) => ({
    isDesktop: width >= breakpoints.desktop,
});
export const Sidebar = withSizes(mapSizesToProps)(SidebarBase);
//# sourceMappingURL=data:application/json;base64,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